import React from "react";
import {
  getPathname,
  Subbrands as SubbrandsComponent,
} from "@italymondo/core-ui";
import { useStaticSubbrandsQuery } from "./query";

export function Subbrands(): React.ReactElement | null {
  const data = useStaticSubbrandsQuery();

  if (!data?.aboutPage[0]) {
    return null;
  }

  return (
    <SubbrandsComponent
      description={data?.aboutPage[0].subBrandsDescription || ""}
      sectionName={data?.aboutPage[0].subBrandsSectionName || ""}
      subbrands={
        data?.aboutPage[0].subBrands.map((s) => ({
          alt: s.brand.logo.title || "",
          src: s.brand.logo.url || "",
          url: getPathname(s.brand.page?.url),
        })) || []
      }
      title={data?.aboutPage[0].subBrandsTitle || ""}
    />
  );
}
